import { TRAIN_MODEL_STATUS } from "../../../utils/constants";
import {
  getCategories,
  generateCollection,
  getCollections,
  getExploreCollections,
  toggleToFavorite,
  getUserFavorites,
  deleteCollection,
  getTrainModels,
  getTrainModel,
  createTrainModel,
  updateTrainModel,
  deleteTrainModel,
  fetchTopCreators,
  regenerateCollection,
  rateModel,
  fetchDefaultGallery,
  selectCoverForTrainModel,
  submitTrainModelForReview,
  getFolders,
  createFolder,
  putCollectionToFolder,
  deleteFolder,
} from "./asyncThunks";

export const getCategoriesBuilder = (builder) => {
  builder.addCase(getCategories.pending, (state) => {
    state.categories.loading = true;
  });
  builder.addCase(getCategories.fulfilled, (state, { payload }) => {
    state.categories.data = payload;
    state.categories.loading = false;
  });
  builder.addCase(getCategories.rejected, (state) => {
    state.categories.loading = false;
    state.categories.error = true;
  });
};

export const getCollectionsBuilder = (builder) => {
  builder.addCase(getCollections.pending, (state) => {
    state.collections.loading = true;
    state.collections.data = null;
  });
  builder.addCase(getCollections.fulfilled, (state, { payload }) => {
    const { data, page, perPage, maxReached, total } = payload;

    // For pagination, always replace data instead of appending

    state.collections.data = data;

    state.collections.maxReached = maxReached;
    state.collections.perPage = +perPage;
    state.collections.page = +page;
    state.collections.total = +total;
    state.collections.loading = false;
    state.collections.hasDataBeenFetched = true;
  });
  builder.addCase(getCollections.rejected, (state) => {
    state.collections.loading = false;
    state.collections.error = true;
  });
};

export const getUserFavoritesBuilder = (builder) => {
  builder.addCase(getUserFavorites.pending, (state) => {
    state.favoriteCollections.loading = true;
    state.favoriteCollections.data = [];
  });
  builder.addCase(getUserFavorites.fulfilled, (state, { payload }) => {
    const { data, page, perPage, maxReached, total } = payload;

    if (+page !== 1) {
      state.favoriteCollections.data = [
        ...state.favoriteCollections.data,
        ...data,
      ];
    } else {
      state.favoriteCollections.data = data;
    }

    state.favoriteCollections.maxReached = maxReached;
    state.favoriteCollections.perPage = +perPage;
    state.favoriteCollections.page = +page;
    state.favoriteCollections.total = +total;
    state.favoriteCollections.loading = false;
    state.favoriteCollections.hasDataBeenFetched = true;
  });
  builder.addCase(getUserFavorites.rejected, (state) => {
    state.favoriteCollections.loading = false;
    state.favoriteCollections.error = true;
  });
};

export const getExploreCollectionsBuilder = (builder) => {
  builder.addCase(getExploreCollections.pending, (state, { meta }) => {
    state.exploreCollections.loading = true;
    state.exploreCollections.data = [];
    state.exploreCollections.page = meta.arg.page;
  });

  builder.addCase(getExploreCollections.fulfilled, (state, { payload }) => {
    const { data, page, perPage, maxReached, total } = payload;

    // For pagination, always replace data instead of appending
    state.exploreCollections.data = data;

    state.exploreCollections.maxReached = maxReached;
    state.exploreCollections.perPage = +perPage;
    state.exploreCollections.page = +page;
    state.exploreCollections.total = +total;
    state.exploreCollections.loading = false;
    state.exploreCollections.hasDataBeenFetched = true;
  });
  builder.addCase(getExploreCollections.rejected, (state) => {
    state.exploreCollections.loading = false;
    state.exploreCollections.error = true;
  });
};

export const generateCollectionBuilder = (builder) => {
  builder.addCase(generateCollection.pending, (state) => {
    state.generateCollection.loading = true;
  });
  builder.addCase(generateCollection.fulfilled, (state, { payload }) => {
    const { collection } = payload.data;

    if (collection) {
      state.collections.page = 1;
      if (state.collections.data) {
        state.collections.data = [collection, ...state.collections.data];
      } else {
        state.collections.data = [collection];
      }
    }

    state.generateCollection.loading = false;
  });
  builder.addCase(generateCollection.rejected, (state) => {
    state.generateCollection.loading = false;
    state.generateCollection.error = true;
  });
};

export const regenerateCollectionBuilder = (builder) => {
  builder.addCase(regenerateCollection.pending, (state) => {
    state.regenerateCollectionPending = true;
  });
  builder.addCase(regenerateCollection.fulfilled, (state, { payload }) => {
    const { collection } = payload.data;

    if (collection) {
      state.collections.page = 1;
      if (state.collections.data) {
        state.collections.data = [collection, ...state.collections.data];
      } else {
        state.collections.data = [collection];
      }
    }

    state.regenerateCollectionPending = false;
  });
  builder.addCase(regenerateCollection.rejected, (state) => {
    state.regenerateCollectionPending = false;
  });
};

export const toggleToFavoriteBuilder = (builder) => {
  builder.addCase(toggleToFavorite.pending, (state) => {
    state.toggleToFavoritePending = true;
  });
  builder.addCase(toggleToFavorite.fulfilled, (state) => {
    state.toggleToFavoritePending = false;
  });
  builder.addCase(toggleToFavorite.rejected, (state) => {
    state.toggleToFavoritePending = false;
  });
};

export const deleteCollectionBuilder = (builder) => {
  builder.addCase(deleteCollection.pending, (state) => {
    state.deleteCollectionPending = true;
  });
  builder.addCase(deleteCollection.fulfilled, (state, { payload }) => {
    const { id } = payload;

    state.collections.data = state.collections.data.filter(
      (collection) => collection._id !== id
    );

    state.deleteCollectionPending = false;
  });
  builder.addCase(deleteCollection.rejected, (state) => {
    state.deleteCollectionPending = false;
  });
};

export const getTrainModelsBuilder = (builder) => {
  builder.addCase(getTrainModels.pending, (state) => {
    state.trainModels.loading = true;
  });
  builder.addCase(getTrainModels.fulfilled, (state, { payload }) => {
    state.trainModels.data = payload.data;
    state.trainModels.loading = false;
    state.trainModels.hasDataBeenFetched = true;
  });
  builder.addCase(getTrainModels.rejected, (state) => {
    state.trainModels.loading = false;
    state.trainModels.error = true;
  });
};

export const getTrainModelBuilder = (builder) => {
  builder.addCase(getTrainModel.pending, (state) => {
    state.selectedTrainModel.loading = true;
  });
  builder.addCase(getTrainModel.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.selectedTrainModel.data = data.trainModel;
    state.selectedTrainModel.loading = false;
    state.selectedTrainModel.trainModelId = data.trainModel._id;
  });
  builder.addCase(getTrainModel.rejected, (state) => {
    state.selectedTrainModel.loading = false;
    state.selectedTrainModel.error = true;
  });
};

export const createTrainModelBuilder = (builder) => {
  builder.addCase(createTrainModel.pending, (state) => {
    state.createTrainModel.loading = true;
  });
  builder.addCase(createTrainModel.fulfilled, (state, { payload }) => {
    const trainModel = payload.data;

    if (trainModel) {
      state.trainModels.data = [trainModel, ...state.trainModels.data];
    }

    state.createTrainModel.loading = false;
  });
  builder.addCase(createTrainModel.rejected, (state) => {
    state.createTrainModel.loading = false;
    state.createTrainModel.error = true;
  });
};

export const updateTrainModelBuilder = (builder) => {
  builder.addCase(updateTrainModel.pending, (state) => {
    state.updateTrainModel.loading = true;
  });
  builder.addCase(updateTrainModel.fulfilled, (state, { payload }) => {
    const { trainModel } = payload.data;

    state.trainModels.data = state.trainModels.data.map((model) =>
      model._id === trainModel._id ? trainModel : model
    );

    if (
      state.selectedTrainModel.data &&
      state.selectedTrainModel.data._id === trainModel._id
    ) {
      state.selectedTrainModel.data = trainModel;
    }

    state.updateTrainModel.loading = false;
  });
  builder.addCase(updateTrainModel.rejected, (state) => {
    state.updateTrainModel.loading = false;
    state.updateTrainModel.error = true;
  });
};

export const deleteTrainModelBuilder = (builder) => {
  builder.addCase(deleteTrainModel.pending, (state) => {
    state.deleteTrainModelPending = true;
  });
  builder.addCase(deleteTrainModel.fulfilled, (state, { payload }) => {
    const { id } = payload;

    state.trainModels.data = state.trainModels.data.filter(
      (trainModel) => trainModel._id !== id
    );

    state.deleteTrainModelPending = false;
  });
  builder.addCase(deleteTrainModel.rejected, (state) => {
    state.deleteTrainModelPending = false;
  });
};

export const getTopCreatorsBuilder = (builder) => {
  builder.addCase(fetchTopCreators.pending, (state) => {
    state.getTopCreatorsPending = true;
  });
  builder.addCase(fetchTopCreators.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.topCreators = data;
    state.getTopCreatorsPending = false;
  });
  builder.addCase(fetchTopCreators.rejected, (state) => {
    state.getTopCreatorsPending = false;
  });
};

export const rateModelBuilder = (builder) => {
  builder.addCase(rateModel.pending, (state, { meta }) => {
    const { collectionId, rating } = meta.arg;
    state.collections.data = state.collections.data.map((item) =>
      item._id === collectionId ? { ...item, rating } : item
    );

    state.rateModelPending = true;
  });
  builder.addCase(rateModel.fulfilled, (state, { payload }) => {
    state.rateModelPending = false;
  });
  builder.addCase(rateModel.rejected, (state) => {
    state.rateModelPending = false;
  });
};

export const getDefaultGalleryBuilder = (builder) => {
  builder.addCase(fetchDefaultGallery.pending, (state) => {
    state.getDefaultGalleryPending = true;
  });
  builder.addCase(fetchDefaultGallery.fulfilled, (state, { payload }) => {
    const data = payload;

    state.gallery.data = data;
    state.getDefaultGalleryPending = false;
  });
  builder.addCase(fetchDefaultGallery.rejected, (state) => {
    state.getDefaultGalleryPending = false;
  });
};

export const selectCoverForTrainModelBuilder = (builder) => {
  builder.addCase(selectCoverForTrainModel.pending, (state) => {
    state.selectCoverForTrainModelPending = true;
  });
  builder.addCase(selectCoverForTrainModel.fulfilled, (state, { payload }) => {
    state.selectCoverForTrainModelPending = false;
  });
  builder.addCase(selectCoverForTrainModel.rejected, (state) => {
    state.selectCoverForTrainModelPending = false;
  });
};

export const submitTrainModelForReviewBuilder = (builder) => {
  builder.addCase(submitTrainModelForReview.pending, (state) => {
    state.submitTrainModelForReviewPending = true;
  });
  builder.addCase(submitTrainModelForReview.fulfilled, (state, { payload }) => {
    state.selectedTrainModel.data.status =
      TRAIN_MODEL_STATUS.SUBMITTED_FOR_REVIEW;
    state.submitTrainModelForReviewPending = false;
  });
  builder.addCase(submitTrainModelForReview.rejected, (state) => {
    state.submitTrainModelForReviewPending = false;
  });
};

export const getCollectionFoldersBuilder = (builder) => {
  builder.addCase(getFolders.pending, (state) => {
    state.collectionFolders.loading = true;
  });
  builder.addCase(getFolders.fulfilled, (state, { payload }) => {
    state.collectionFolders.data = payload;
    state.collectionFolders.loading = false;
  });
  builder.addCase(getFolders.rejected, (state) => {
    state.collectionFolders.loading = false;
  });
};

export const createCollectionFolderBuilder = (builder) => {
  builder.addCase(createFolder.pending, (state) => {
    state.createFolderPending = true;
  });
  builder.addCase(createFolder.fulfilled, (state, { payload }) => {
    state.collectionFolders.data = [...state.collectionFolders.data, payload];
    state.createFolderPending = false;
  });
  builder.addCase(createFolder.rejected, (state) => {
    state.createFolderPending = false;
  });
};

export const putCollectionToFolderBuilder = (builder) => {
  builder.addCase(putCollectionToFolder.pending, (state) => {
    state.putCollectionToFolderPending = true;
  });
  builder.addCase(putCollectionToFolder.fulfilled, (state, { payload }) => {
    if (state.collections.data) {
      state.collections.data = state.collections.data.map((c) =>
        c._id === payload._id ? payload : c
      );
    }

    state.putCollectionToFolderPending = false;
  });
  builder.addCase(putCollectionToFolder.rejected, (state) => {
    state.putCollectionToFolderPending = false;
  });
};

export const deleteCollectionFolderBuilder = (builder) => {
  builder.addCase(deleteFolder.pending, (state) => {
    state.deleteFolderPending = true;
  });
  builder.addCase(deleteFolder.fulfilled, (state, { payload }) => {
    state.collectionFolders.data = state.collectionFolders.data.filter(
      (el) => el.name !== payload.name
    );
    state.deleteFolderPending = false;
  });
  builder.addCase(deleteFolder.rejected, (state) => {
    state.deleteFolderPending = false;
  });
};
